





































import { Vue, Watch, Component, Prop } from 'vue-property-decorator';
import { State, Mutation, Getter } from 'vuex-class';
import { Design } from '@/types';
import { FotowandCanvasManager } from '@/lib/CanvasManager/FotowandCanvasManager';

@Component({})
export default class Dimensions extends Vue {
  @State((state) => state.canvas.manager) canvasManager!: FotowandCanvasManager;
  @State((state) => state.design.design) design!: Design;
  @Getter('types/canvas') CANVASType;
  @Getter('types/behang') BEHANGType;
  @Mutation('design/setDesignDimensions') setDesignDimensions;
  currentWidth = 0;
  currentHeight = 0;
  isAltered = false;

  cacheDimensions: {
    width: number;
    height: number;
  } = {
    width: null,
    height: null,
  };

  dimensions: {
    CANVAS: {
      minWidth?: number;
      minHeight?: number;
      maxWidth?: number;
      maxHeight?: number;
      defaultWidth?: number;
      defaultHeight?: number;
      width?: number;
      height?: number;
    };
    BEHANG: {
      minWidth?: number;
      minHeight?: number;
      maxWidth?: number;
      maxHeight?: number;
      defaultWidth?: number;
      defaultHeight?: number;
      width?: number;
      height?: number;
    };
  } = {
    CANVAS: {
      minWidth: 20,
      maxWidth: 2000,
      minHeight: 20,
      maxHeight: 315,
      width: 400,
      height: 200,
    },
    BEHANG: {
      minWidth: 100,
      maxWidth: 2500,
      minHeight: 100,
      maxHeight: 305,
      width: 400,
      height: 200,
    },
  };

  @Watch('mode')
  async onModeChange(mode, oldMode) {
    if (!this.isAltered) {
      this.designHeight = this.cacheDimensions.height;
      this.designWidth = this.cacheDimensions.width;

      return;
    }

    this.isAltered = false;

    this.cacheDimensions = {
      width: this.dimensions[oldMode].width,
      height: this.dimensions[oldMode].height,
    };

    this.setDesignDimension({
      value: this.dimensions[mode].width,
      type: 'Width',
    });
    this.setDesignDimension({
      value: this.dimensions[mode].height,
      type: 'Height',
    });
  }

  @Prop(String) readonly mode: string;
  get width() {
    return this.design?.dimensions.width;
  }
  set width(value) {
    this.setDesignDimensions({ width: parseInt(value) || this.width });
  }
  get height() {
    return this.design?.dimensions.height;
  }
  set height(value) {
    this.setDesignDimensions({ height: parseInt(value) || this.height });
  }

  get designWidth() {
    return this.currentWidth;
  }
  set designWidth(val) {
    const value = +val;
    this.currentWidth = value;
    this.dimensions[this.mode].width = value;
    this.onDimensionChange({
      value,
      type: 'Width',
    });
  }

  get designHeight() {
    return this.currentHeight;
  }
  set designHeight(val) {
    const value = +val;
    this.currentHeight = value;
    this.dimensions[this.mode].height = value;
    this.onDimensionChange({
      value,
      type: 'Height',
    });
  }

  async created() {
    window.fotowandDesigner.setDimensions = ({ type = this.mode, width, height }) => {
      if (width) {
        this.dimensions[type].width = +width;
        if (type === this.mode) {
          this.designWidth = +width;
        }
      }
      if (height) {
        this.dimensions[type].height = +height;
        if (type === this.mode) {
          this.designHeight = +height;
        }
      }
    };
  }

  async mounted() {
    await this.$nextTick();
    await this.setDefaults();

    if (this.height) {
      await this.setDesignDimension({
        value: this.height,
        type: 'Height',
      });
    }
    if (this.width) {
      await this.setDesignDimension({
        value: this.width,
        type: 'Width',
      });
    }

    this.$root.$on('canvas:ready', () => {
      this.updateCanvas();
    });

    this.isAltered = true;
  }

  async setDefaults() {
    const modes = ['CANVAS', 'BEHANG'];

    for (const mode of modes) {
      if (!this[`${mode}Type`]) {
        break;
      }

      this.dimensions[mode] = { ...this[`${mode}Type`].dimensions };
      this.dimensions[mode].width = +this.dimensions[mode].defaultWidth;
      this.dimensions[mode].height = +this.dimensions[mode].defaultHeight;

      if (this.mode === mode) {
        if (this.width === null || typeof this.width === 'undefined') {
          await this.setDesignDimension({
            value: this.dimensions[mode].width,
            type: 'Width',
          });
        }

        if (this.height === null || typeof this.height === 'undefined') {
          await this.setDesignDimension({
            value: this.dimensions[mode].height,
            type: 'Height',
          });
        }
      }
    }
  }

  async onDimensionChange({ value, type }) {
    if (
      !this.checkDimension({
        value,
        type,
      })
    ) {
      return;
    }

    this.isAltered = true;

    await this.setDesignDimension({
      value,
      type,
    });
  }

  async setDesignDimension({ value, type }) {
    const prop = type.toLowerCase();
    const dimensions = this.dimensions[this.mode];

    if (value > dimensions[`max${type}`]) {
      value = dimensions[`max${type}`];
    } else if (value < dimensions[`min${type}`]) {
      value = dimensions[`min${type}`];
    }

    dimensions[prop] = value;

    this[`current${type}`] = value;
    this[prop] = value;

    await this.updateCanvas();

    //this.$forceUpdate();
  }

  checkDimension({ value, type }) {
    const prop = type.toLowerCase();
    if (!value) {
      return false;
    }

    const dimensions = this.dimensions[this.mode];
    if (dimensions[prop]) {
      if (value > dimensions[`max${type}`]) {
        return false;
      } else if (value < dimensions[`min${type}`]) {
        return false;
      }
    }

    return true;
  }

  async updateCanvas() {
    await this.canvasManager.resizeDesignRect(this.width, this.height);
    this.$emit('canvasUpdate', { detail: this.canvasManager.selectedObject });
  }
}
